package org.bsvac.bsvac_kmp.data

import androidx.compose.foundation.text.TextAutoSize
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.sp

data class BsvacTextStyle (val fontSize: TextUnit) {
    fun stepBasedAutoSize(): TextAutoSize {
        return TextAutoSize.StepBased(
            minFontSize = fontSize/3,
            maxFontSize = fontSize,
            stepSize = 1.sp
        )
    }
}
enum class TextSizes {
    LARGE
}

fun adjustedTextSize(defaultFontSize: TextUnit, adjustment: TextSizes): TextUnit {
    return when (adjustment) {
        TextSizes.LARGE -> defaultFontSize.times(1.2)
    }
}